import React from "react";

export default function ExperimentWizardIntro({
  steps = [],
  currentStepNumber = 1,
  description = "",
}) {
  if (!steps.length) return null;

  const visibleSteps = steps.slice(0, currentStepNumber);

  return (
    <div className="form-shell__intro experiment-wizard-intro">
      <div className="dataset-flow-shell__eyebrow">
        <div className="dataset-flow-shell__step-flow">
          {visibleSteps.map((stepLabel, index) => {
            const stepNumber = index + 1;
            const isCurrent = stepNumber === currentStepNumber;

            return (
              <div
                key={`${stepLabel}-${stepNumber}`}
                className="dataset-flow-shell__step-item"
              >
                {isCurrent ? (
                  <span className="dataset-flow-shell__step-badge">
                    Step {stepNumber}
                  </span>
                ) : (
                  <span className="dataset-flow-shell__step-marker">
                    {stepNumber}
                  </span>
                )}
                <span
                  className={`dataset-flow-shell__step-name ${
                    isCurrent ? "dataset-flow-shell__step-name--active" : ""
                  }`}
                >
                  {stepLabel}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {description ? (
        <p className="experiment-wizard-intro__description mb-0 from-shell-sub-text">
          {description}
        </p>
      ) : null}
    </div>
  );
}
